import React, { useEffect, useState, useRef } from 'react';
import { Popover } from 'antd';
import { ReactComponent as CopyIconCpay } from '../../../img/cpay-svg/copy-blue.svg';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SuccessSVG } from '../../../img/default-svg/success.svg';
import network from '../../../utils/transactionScans';
import { truncate } from '../../../utils/truncateFunction';
import { tokenNodeTypeObj } from '../../../utils/tokenNodeTypes';
import '../Success/style.scss';
import PartialWarningMsg from '../PartialWarningMsg/PartialWarningMsg';
import { identity } from '../../../utils/getIdentity';

const Partial = ({ replenish, fiatCurrency, wallets, typeNetwork, selectedCurrency, systemStatus, accentColor }) => {
 // const { amount, currency, price } = replenish;
  const [showCopyPopover, setShowCopyPopover] = useState(false);
  const copyTimer = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      if (copyTimer.current) {
        clearTimeout(copyTimer.current);
        copyTimer.current = null;
      }
    };
  }, []);

  const copyHandler = value => {
    navigator.clipboard.writeText(value);
    setShowCopyPopover(true);
    copyTimer.current = setTimeout(() => setShowCopyPopover(false), 1000);
  };

  const notIncludedNodeType = ['optimism', 'matic', 'arbitrum', 'avax', 'sol', 'ftm', 'moonbeam']

  const linkSolana = replenish?.currency === 'SOL' ? '?cluster=devnet' : ''

  return (
    <>
      <style>
        {`
          .checkout-success__info-block svg path {
            stroke: ${accentColor} !important;
          }
          .checkout-success__info-block.checkout-hash a:hover {
            color: ${accentColor} !important;
          }
        `}
      </style>
      <div className="checkout-success">
       {replenish &&  <PartialWarningMsg selectedCurrency={selectedCurrency} replenish={replenish} systemStatus={systemStatus} />}
        <SuccessSVG />
        <div className={`checkout-success__title checkout-success__title-${identity}`}>{t('checkouts.partial.title')}!</div>
        <div className="checkout-success__subtitle">{t('checkouts.partial.subtitle')}</div>

        <div className="checkout-success__info-block">
          <div>{t('amount')}</div>
          <div className="checkout-partial-success__info-block_wrapper">
            <div>{`${replenish?.amount.value} ${replenish?.currency}`}</div>
            {replenish?.currencyType === 'token' ? <div>{tokenNodeTypeObj[replenish?.nodeType]}</div> : ''}
          </div>
        </div>
        <div className="checkout-success__info-block">
          <div className="exchange-rate">{t('withdraw.exchangeRate')}</div>
          <div>{`1 ${replenish?.currency}
           ${
            replenish?.currencyType === 'token' && !notIncludedNodeType.includes(replenish?.nodeType) ? tokenNodeTypeObj[replenish?.nodeType] : ''
          }
          ${
            replenish?.currencyType === 'token' && replenish?.nodeType === 'optimism' ?
            replenish?.currency === 'OP' ? '' : 'OP' : ''
          }
          ${
           replenish?.currency === 'ETH' && replenish?.currencyType === 'currency' && replenish?.nodeType === 'optimism' ?
            'OP' : ''
          }

          ${replenish?.currencyType === 'currency' && replenish?.nodeType === 'arbitrum' ? replenish?.currency === 'arbitrum' ? '' : 'ARB' : ''}

          ${replenish?.currencyType === 'currency' && replenish?.nodeType === 'currency' ? 'BASE' : ''}
          ${replenish?.currencyType === 'token' && replenish?.nodeType === 'currency' ? 'BASE' : ''}
          ${(replenish?.currency === 'USDT' || replenish?.currency === 'USDC' || replenish?.currency === 'ETH') && replenish?.currencyType === 'token' && replenish?.nodeType === 'arbitrum' ? 'ARB' : ''}

          ${(replenish?.currency === 'USDT' || replenish?.currency === 'USDC') && replenish?.currencyType === 'token' && replenish?.nodeType === 'matic' ? 'MATIC' : ''}

          
          ${(replenish?.currency === 'USDT' && replenish?.currencyType === 'token' && replenish?.nodeType === 'avax') ? 'AVAX' : ''}

         ${(replenish?.currency === 'USDC' && replenish?.currencyType === 'token' && replenish?.nodeType === 'solana') ? 'SOL' : ''}

        ${(replenish?.currency === 'USDT'  && replenish?.currencyType === 'token' && replenish?.nodeType === 'ftm') ? 'FTM' : ''}

          ${((replenish?.currency === 'USDT' || replenish?.currency === 'USDC') && replenish?.currencyType === 'token' && replenish?.nodeType === 'moonbeam') ? 'GLMR' : ''}
          - ${replenish?.price} ${fiatCurrency}`}</div>
        </div>
        <div className="checkout-success__info-block checkout-hash">
          <div>Hash:</div>
          <div>
            <a
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
              href={`${network[typeNetwork][replenish?.nodeType]}${replenish?.hash}${linkSolana}`}
              className={`link link-${identity}`}
            >
              {truncate(replenish?.hash, 15)}{' '}
            </a>
            <Popover title="" content={t('copied')} trigger="click" visible={showCopyPopover}>
              <CopyIconCpay onClick={() => copyHandler(replenish?.hash)} />
            </Popover>
          </div>
        </div>
      </div>
    </>
  );
};

export default Partial;
